<template>
    <div id="topic-mapping-detail">
        <v-breadcrumbs :items="items" divider="|"></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ grade.display_name }}
            {{
                grade.jenjang.nama === "SMA" &&
                $route.query.interest === "SAINTEK"
                    ? "IPA"
                    : ""
            }}{{
                grade.jenjang.nama === "SMA" &&
                $route.query.interest === "SOSHUM"
                    ? "IPS"
                    : ""
            }}
        </h3>

        <v-card v-if="$route.query.mapel">
            <v-card-text class="py-0 px-1 ma-0">
                <v-container fluid>
                    <v-row no-gutters>
                        <v-col cols="*">
                            <v-text-field
                                v-model="query"
                                outlined
                                height="36px"
                                hide-details
                                small
                                dense
                                class="search_box"
                                placeholder="Ketik kata kunci dan tekan enter"
                            >
                                <template slot="prepend-inner">
                                    <svg
                                        style="margin-top: 10px !important"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                            fill="#073554"
                                        />
                                        <path
                                            d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                            fill="#073554"
                                        />
                                    </svg>
                                </template>
                                <template slot="append-outer">
                                    <v-btn
                                        class="align-center text-body-2 blew white--text"
                                        plain
                                        dark
                                        @click="showMappingModal = true"
                                        ><v-icon small class="pr-2"
                                            >mdi-plus-circle</v-icon
                                        >
                                        Mapping
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="pa-4">
                <v-row>
                    <v-col
                        cols="4"
                        class="pa-3"
                        v-for="card in filteredCards"
                        v-bind:key="card.id"
                    >
                        <v-card flat outlined>
                            <v-card-title>
                                <v-list class="pa-0 ma-0" width="100%">
                                    <v-list-item class="pa-0 ma-0">
                                        <v-list-item-content class="pa-0 ma-0">
                                            <v-list-item-title
                                                class="text-subtitle-1 font-weight-bold black--text"
                                                style="
                                                    word-break: break-word !important;
                                                "
                                            >
                                                {{ card.name }}
                                            </v-list-item-title>
                                        </v-list-item-content>

                                        <v-list-item-action
                                            class="pa-0 ma-0 align-self-start justify-self-end"
                                        >
                                            <v-btn
                                                icon
                                                small
                                                v-if="allowDeletion(card)"
                                                color="redLight"
                                                @click="confirmDeletion(card)"
                                                ><v-icon
                                                    >mdi-close-circle</v-icon
                                                ></v-btn
                                            >
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-card-title>
                            <v-card-subtitle
                                >Kode: {{ card.code }}</v-card-subtitle
                            >
                            <v-card-actions class="justify-center">
                                <v-btn
                                    v-if="!subBab"
                                    color="blew"
                                    text
                                    @click="setParams(card)"
                                    style="text-decoration: none"
                                    >Lihat Detail</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col v-if="!filteredCards.length">
                        <div cols="12" class="pa-3 text-center">
                            Data tidak tersedia
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card v-else>
            <v-card-title>
                Daftar Mata Pelajaran
                <v-spacer></v-spacer>

                <v-btn
                    class="align-center text-body-2 blew white--text"
                    plain
                    dark
                    @click="showMappingModal = true"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Mapping
                </v-btn>
            </v-card-title>
            <v-divider />

            <v-card-text class="pa-0 ma-0">
                <v-container fluid>
                    <v-row no-gutters>
                        <v-col>
                            <v-text-field
                                outlined
                                height="36px"
                                hide-details
                                small
                                dense
                                class="search_box"
                                v-model="query"
                                placeholder="Ketik kata kunci dan tekan enter"
                            >
                                <template slot="prepend-inner">
                                    <svg
                                        style="margin-top: 10px !important"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                            fill="#073554"
                                        />
                                        <path
                                            d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                            fill="#073554"
                                        />
                                    </svg>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-list three-line style="min-height: none !important">
                <template>
                    <v-list-item
                        v-for="card in filteredCards"
                        v-bind:key="card.id"
                        @click="setParams(card)"
                    >
                        <v-list-item-avatar>
                            <v-img
                                :src="
                                    card.picture
                                        ? card.picture
                                        : '@/assets/blank.svg'
                                "
                                :style="
                                    $vuetify.breakpoint.smAndDown
                                        ? 'background-size:20px'
                                        : ''
                                "
                            ></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content
                            v-if="$vuetify.breakpoint.mdAndUp"
                            class="pt-4 pb-6"
                        >
                            <v-list-item-title>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    {{ card.name }}
                                </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Kode: {{ card.code }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="d-flex align-self-center">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>

        <v-dialog
            v-if="deletedCard && showConfirmationModal"
            v-model="showConfirmationModal"
            @click:outside="showConfirmationModal = false"
            max-width="506px"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title style="word-break: break-word !important">
                        Apakah Anda yakin akan melakukan penghapusan mapping?
                    </v-card-title>
                    <v-card-text>
                        Kamu akan menghapus
                        <strong style="color: red">
                            {{ deletedCard.name }}
                        </strong>
                        beserta sub bab / sub sub bab turunannya
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            color="red darken-1"
                            text
                            @click="dialog.value = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            color="blew darken-1"
                            text
                            @click="deleteMapping()"
                        >
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <topic-mapping-modal
            v-on:finish="onMappingFinished($event)"
            :topic="selectedCard"
            v-on:cancel="showMappingModal = false"
            v-if="showMappingModal"
        ></topic-mapping-modal>
    </div>
</template>

<script>
import ItembankService from "@/modules/itembank/services/itembank.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TopicMappingModal from "@/modules/kodifikasi/components/MappingModal";

export default {
    name: "topic-mapping-detail",

    data: function () {
        return {
            grade: null,
            defaultCards: [],
            cards: [],
            filteredCards: [],
            selectedCard: null,
            deletedCard: null,
            bgColors: ["bg-green", "bg-blue", "bg-purple", "bg-red"],
            showMappingModal: false,
            showConfirmationModal: false,
            isLoading: false,
            mapelId: null,
            babId: null,
            subBabId: null,
            subSubBabId: null,
            mapel: null,
            bab: null,
            subBab: null,
            subSubBab: null,
            breadcrumbs: [],
            query: "",
            items: [],
        };
    },

    components: {
        "topic-mapping-modal": TopicMappingModal,
        "app-spinner": Spinner,
    },

    methods: {
        initBreadcrumbs: function () {
            this.items = [];

            this.items.push(
                { text: "Kodifikasi", to: { path: "/" } },
                {
                    text: "Mapping",
                    to: { path: "/topic-mapping" },
                    exact: true,
                },
                {
                    text:
                        this.grade.jenjang.nama === "SMA" &&
                        this.$route.query.interest === "SAINTEK"
                            ? this.grade.display_name + " IPA"
                            : "" ||
                                (this.grade.jenjang.nama === "SMA" &&
                                    this.$route.query.interest === "SOSHUM")
                              ? this.grade.display_name + " IPS"
                              : this.grade.display_name,
                    to: {
                        path: "/topic-mapping/detail",
                        query: {
                            interest: this.$route.query.interest,
                            grade_id: this.$route.query.grade_id,
                        },
                    },
                    exact: true,
                },
            );

            if (this.mapel) {
                this.items.push({
                    text: this.mapel.name,
                    to: {
                        path: "/topic-mapping/detail",
                        query: {
                            interest: this.$route.query.interest,
                            grade_id: this.$route.query.grade_id,
                            mapel: this.mapel.id,
                        },
                    },
                    exact: true,
                });
            }

            if (this.bab) {
                this.items.push({
                    text: this.bab.name ? this.bab.name : this.bab.bab_name,
                    to: {
                        path: "/topic-mapping/detail",
                        query: {
                            interest: this.$route.query.interest,
                            grade_id: this.$route.query.grade_id,
                            mapel: this.mapel.id,
                            bab: this.bab.id ? this.bab.id : this.bab.bab_id,
                        },
                    },
                    exact: true,
                });
            }

            if (this.subBab) {
                this.items.push({
                    text: this.subBab.name
                        ? this.subBab.name
                        : this.subBab.sub_bab_name,
                    to: {
                        path: "/topic-mapping/detail",
                        query: {
                            interest: this.$route.query.interest,
                            grade_id: this.$route.query.grade_id,
                            mapel: this.mapel.id,
                            bab: this.bab.id ? this.bab.id : this.bab.bab_id,
                            sub_bab: this.subBab.id
                                ? this.subBab.id
                                : this.subBab.sub_bab_id,
                        },
                    },
                    exact: true,
                });
            }
        },

        resetCards: function () {
            this.mapelId = null;
            this.babId = null;
            this.subBabId = null;
            this.cards = [];
            this.breadcrumbs = [];

            var queryParams = JSON.parse(JSON.stringify(this.$route.query));
            delete queryParams.mapel;
            delete queryParams.bab;
            delete queryParams.sub_bab;
            this.$router.replace({ query: queryParams });

            var mappings = this.$ls.get("mappings");
            var context = this;
            mappings.forEach(function (data) {
                var card = {
                    id: data.mapel_id,
                    type: "mapel",
                    code: data.mapel_code,
                    picture: data.mapel_picture,
                    name: data.mapel_name,
                    subs: data.babs,
                };

                context.cards.push(card);
            });
        },

        goTo: function (crumbIndex) {
            this.mapelId = null;
            this.babId = null;
            this.subBabId = null;

            var queryParams = JSON.parse(JSON.stringify(this.$route.query));
            var context = this;
            this.breadcrumbs.splice(crumbIndex + 1);
            this.breadcrumbs.forEach(function (crumb) {
                if (crumb.type === "mapel") {
                    context.mapelId = crumb.id;
                }
                if (crumb.type === "bab") {
                    context.babId = crumb.id;
                }
                if (crumb.type === "sub_bab") {
                    context.subBabId = crumb.id;
                }
            });
            if (this.breadcrumbs[crumbIndex].type == "mapel") {
                delete queryParams.bab;
                delete queryParams.sub_bab;
            } else if (this.breadcrumbs[crumbIndex].type == "bab")
                delete queryParams.sub_bab;

            this.$router.replace({ query: queryParams });

            this.selectedCard = this.breadcrumbs[this.breadcrumbs.length - 1];
        },

        bgColor: function (id) {
            var index = id % 4;
            return this.bgColors[index];
        },

        onMappingFinished: function (mappings) {
            var interest = this.$route.query.interest;
            var gradeId = parseInt(this.$route.query.grade_id, 10);
            var context = this;
            this.cards = [];

            ItembankService.getTopicMappings(
                this.grade.id,
                interest,
                function (response) {
                    if (response.success) {
                        context.$ls.set("mappings", response.data);
                        response.data.forEach(function (data) {
                            var card = {
                                id: data.mapel_id,
                                type: "mapel",
                                code: data.mapel_code,
                                picture: data.mapel_picture,
                                name: data.mapel_name,
                                subs: data.babs,
                            };

                            context.cards.push(card);
                        });
                    }
                    context.showMappingModal = false;
                },
            );
            setTimeout(() => {
                this.reSync();
            }, 150);
        },

        confirmDeletion: function (card) {
            this.showConfirmationModal = true;
            this.deletedCard = card;

            if (this.deletedCard.type === "sub_bab") this.subBabId = card.id;
            if (this.deletedCard.type === "sub_sub_bab")
                this.subSubBabId = card.id;
        },

        allowDeletion: function (card) {
            if (card.type === "sub_bab") return true;
            if (card.type === "sub_sub_bab") return true;

            return false;
        },

        deleteMapping: function () {
            this.showConfirmationModal = false;
            this.isloading = true;
            var context = this;

            ItembankService.deleteTopicMapping(
                this.mapelId,
                this.babId,
                this.subBabId,
                this.subSubBabId,
                this.$route.query.grade_id,
                this.$route.query.interest,
                function (response) {
                    if (response.success) {
                        var removeIndex = context.cards.findIndex(
                            function (card) {
                                return card.id === context.deletedCard.id;
                            },
                        );

                        context.cards.splice(removeIndex, 1);
                    }

                    context.isLoading = false;
                },
            );
            setTimeout(() => {
                this.reSync();
            }, 150);
        },

        updateBreadcrumbs: function (card) {
            if (this.breadcrumbs.length > 0) {
                var last = this.breadcrumbs[this.breadcrumbs.length - 1];
                if (card.type !== last.type) this.breadcrumbs.push(card);
            } else {
                this.breadcrumbs.push(card);
            }
        },

        readParams() {
            var context = this;
            if (
                context.$route.query.mapel &&
                context.$route.query.bab &&
                context.$route.query.sub_bab
            ) {
                const found = context.defaultCards.find(
                    (x) => x.id == Number(context.$route.query.mapel),
                );
                const found_sub = found.subs.find(
                    (x) => x.bab_id == Number(context.$route.query.bab),
                );
                const found_sub_sub = found_sub.sub_babs.find(
                    (x) => x.sub_bab_id == Number(context.$route.query.sub_bab),
                );
                found_sub_sub.type = "sub_bab";
                context.selectedCard = found_sub_sub;

                if (this.breadcrumbs.length <= 1) {
                    context.updateBreadcrumbs(found);
                    context.updateBreadcrumbs(found_sub);
                    context.updateBreadcrumbs(found_sub_sub);
                }

                this.mapelId = context.$route.query.mapel;
                this.babId = context.$route.query.bab;
                this.subBabId = context.$route.query.sub_bab;
                this.subSubBabId = context.$route.query.sub_sub_bab;
            } else if (context.$route.query.mapel && context.$route.query.bab) {
                const found = context.defaultCards.find(
                    (x) => x.id == Number(context.$route.query.mapel),
                );
                const found_sub = found.subs.find(
                    (x) => x.bab_id == Number(context.$route.query.bab),
                );
                found_sub.type = "bab";

                this.mapelId = context.$route.query.mapel;
                this.babId = context.$route.query.bab;
                this.subBabId = context.$route.query.sub_bab;
                this.subSubBabId = context.$route.query.sub_sub_bab;

                context.selectedCard = found_sub;
                if (this.breadcrumbs.length <= 1) {
                    context.updateBreadcrumbs(found);
                    context.updateBreadcrumbs(found_sub);
                }
            } else if (context.$route.query.mapel) {
                context.selectedCard = null;
                const found = context.defaultCards.find(
                    (x) => x.id == Number(context.$route.query.mapel),
                );
                found.type = "mapel";
                context.selectedCard = found;
                if (this.breadcrumbs.length <= 1) {
                    context.updateBreadcrumbs(found);
                }

                this.mapelId = context.$route.query.mapel;
                this.babId = context.$route.query.bab;
                this.subBabId = context.$route.query.sub_bab;
                this.subSubBabId = context.$route.query.sub_sub_bab;
            }
        },

        setParams(val) {
            var queryParams = JSON.parse(JSON.stringify(this.$route.query));
            if (val.type === "mapel") {
                this.mapelId = val.id;
                queryParams.mapel = val.id;
            } else if (val.type === "bab") {
                this.babId = val.bab_id;
                queryParams.bab = val.id;
            } else if (val.type === "sub_bab") {
                this.subBabId = val.sub_bab_id;
                queryParams.sub_bab = val.id;
            } else if (val.type === "sub_sub_bab") {
                this.subSubBabId = val.sub_sub_bab_id;
                queryParams.sub_sub_bab = val.id;
            }

            this.$router.replace({ query: queryParams });
        },

        reSync() {
            var context = this;
            var interest = this.$route.query.interest;
            var newCards = [];

            ItembankService.getTopicMappings(
                this.grade.id,
                interest,
                function (response) {
                    if (response.success) {
                        context.$ls.set("mappings", response.data);
                        response.data.forEach(function (data) {
                            var card = {
                                id: data.mapel_id,
                                type: "mapel",
                                code: data.mapel_code,
                                picture: data.mapel_picture,
                                name: data.mapel_name,
                                subs: data.babs,
                            };

                            newCards.push(card);
                        });
                    }
                },
            );
            context.defaultCards = newCards;
            setTimeout(() => {
                this.readParams();
            }, 150);
        },

        reSyncMapel() {
            var context = this;

            if (!this.$route.query.mapel) {
                context.mapel = null;
                context.cards = context.defaultCards;
                context.filteredCards = context.cards;
            } else {
                var mapelId = parseInt(this.$route.query.mapel);
                var found = context.cards.find(function (card) {
                    return card.id === mapelId;
                });

                if (found !== undefined) {
                    context.mapel = found;
                    context.cards = context.mapel.subs;
                    context.filteredCards = context.cards;
                }
            }
            context.initBreadcrumbs();
        },

        reSyncBab() {
            var context = this;

            if (!this.$route.query.bab) {
                context.bab = null;
                if (context.mapel) {
                    context.cards = context.mapel.subs;
                    context.filteredCards = context.cards;
                }
            } else {
                var babId = parseInt(this.$route.query.bab);
                var found = context.cards.find(function (card) {
                    return card.id ? card.id === babId : card.bab_id === babId;
                });

                if (found !== undefined) {
                    context.bab = found;
                    context.cards = context.bab.subs
                        ? context.bab.subs
                        : context.bab.sub_babs;
                    context.filteredCards = context.cards;
                }
            }
            context.initBreadcrumbs();
        },

        reSyncSubBab() {
            var context = this;

            if (!this.$route.query.sub_bab) {
                context.subBab = null;
                if (context.bab) {
                    context.cards = context.bab.subs;
                    context.filteredCards = context.cards;
                }
            } else {
                var subBabId = parseInt(this.$route.query.sub_bab);
                var found = context.cards.find(function (card) {
                    return card.id
                        ? card.id === subBabId
                        : card.sub_bab_id === subBabId;
                });

                if (found !== undefined) {
                    context.subBab = found;
                    context.cards = context.subBab.subs
                        ? context.subBab.subs
                        : context.subBab.sub_sub_babs;
                    context.filteredCards = context.cards;
                }
            }
            context.initBreadcrumbs();
        },
    },

    watch: {
        query: function (val) {
            this.filteredCards = [];
            var filteredCards = this.cards.filter(function (card) {
                return card.name.toLowerCase().includes(val.toLowerCase());
            });

            this.filteredCards = filteredCards;
        },

        cards: function (val) {
            this.filteredCards = [];
            this.filteredCards = val;
            this.query = "";
        },

        selectedCard: function (val) {
            this.cards = [];
            var context = this;
            var queryParams = JSON.parse(JSON.stringify(this.$route.query));
            if (val.type === "mapel") {
                // this.mapelId = val.id
            } else if (val.type === "bab") {
                val.subs = val.sub_babs;
            } else if (val.type === "sub_bab") {
                val.subs = val.sub_sub_babs;
            } else if (val.type === "sub_sub_bab") {
                val.subs = val.sub_sub_babs;
            }

            this.$router.replace({ query: queryParams });

            val.subs.forEach(function (sub) {
                if (val.type == "mapel") {
                    var card = {
                        id: sub.bab_id,
                        type: "bab",
                        code: sub.bab_code,
                        picture:
                            "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                        name: sub.bab_name,
                        subs: sub.sub_babs,
                    };
                    queryParams.mapel = val.id;
                    context.cards.push(card);
                } else if (val.type == "bab") {
                    var card = {
                        id: sub.sub_bab_id,
                        type: "sub_bab",
                        code: sub.sub_bab_code,
                        picture:
                            "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                        name: sub.sub_bab_name,
                        subs: sub.sub_sub_babs,
                    };

                    queryParams.bab = val.id;
                    context.cards.push(card);
                } else if (val.type == "sub_bab") {
                    var card = {
                        id: sub.sub_sub_bab_id,
                        type: "sub_sub_bab",
                        code: sub.sub_sub_bab_code,
                        picture:
                            "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                        name: sub.sub_sub_bab_name,
                        subs: [],
                    };

                    queryParams.sub_bab = val.id;
                    context.cards.push(card);
                }
            });
            this.updateBreadcrumbs(val);
        },

        $route(to, from) {
            setTimeout(() => {
                this.readParams();
            }, 150);
        },

        "$route.query.mapel": function () {
            this.reSyncMapel();
        },

        "$route.query.bab": function () {
            this.reSyncBab();
        },

        "$route.query.sub_bab": function () {
            this.reSyncSubBab();
        },
    },

    mounted() {
        setTimeout(() => {
            this.reSyncMapel();
            this.reSyncBab();
            this.reSyncSubBab();
            this.readParams();
        }, 1000);
    },

    beforeMount: function () {
        var interest = this.$route.query.interest;
        var gradeId = parseInt(this.$route.query.grade_id, 10);
        var grades = this.$ls.get("grades");
        var found = grades.find(function (grade) {
            return grade.id === gradeId;
        });

        if (found) this.grade = found;
        var context = this;
        ItembankService.getTopicMappings(
            this.grade.id,
            interest,
            function (response) {
                if (response.success) {
                    context.defaultCards = [];
                    context.cards = [];
                    context.$ls.set("mappings", response.data);
                    response.data.forEach(function (data) {
                        var card = {
                            id: data.mapel_id,
                            type: "mapel",
                            code: data.mapel_code,
                            picture: data.mapel_picture,
                            name: data.mapel_name,
                            subs: data.babs,
                        };

                        context.defaultCards.push(card);
                        context.cards.push(card);
                    });
                    context.initBreadcrumbs();
                }
            },
        );
    },
};
</script>



// WEBPACK FOOTER //
// TopicMappingDetail.vue?72d42693